import React, { useMemo } from 'react';
import {
  AppBar,
  Box,
  Button,
  Container,
  Stack,
  Toolbar,
  Typography,
} from '@mui/material';
import LoginIcon from '@mui/icons-material/Login';
import ThemeModeToggle from '../components/ThemeModeToggle';
import { getAdminSignInUrl } from '../lib/domainRouting';

/**
 * Public marketing / support landing surface (non-admin hostnames).
 * Embeds the chat widget iframe; Sign In sends users to the Back Office subdomain.
 */
export default function LandingPage() {
  const signInUrl = useMemo(() => getAdminSignInUrl(), []);

  const handleSignIn = () => {
    window.location.assign(signInUrl);
  };

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
      <AppBar position="static" color="transparent" elevation={0} sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Toolbar>
          <Typography variant="h6" sx={{ flexGrow: 1, fontWeight: 700 }}>
            Shifty PM
          </Typography>
          <Stack direction="row" spacing={1} alignItems="center">
            <ThemeModeToggle />
            <Button
              variant="contained"
              startIcon={<LoginIcon />}
              onClick={handleSignIn}
            >
              Sign In
            </Button>
          </Stack>
        </Toolbar>
      </AppBar>

      <Container maxWidth="md" sx={{ py: { xs: 6, md: 10 } }}>
        <Stack spacing={3} alignItems="flex-start">
          <Typography variant="h3" fontWeight={800} sx={{ letterSpacing: -0.5 }}>
            Project management, powered by AI
          </Typography>
          <Typography variant="h6" color="text.secondary" sx={{ maxWidth: 560, fontWeight: 400 }}>
            Tickets, code review, and team operations in one place. Sign in to open
            the Back Office.
          </Typography>
          <Button
            size="large"
            variant="contained"
            startIcon={<LoginIcon />}
            onClick={handleSignIn}
          >
            Sign In to Back Office
          </Button>
        </Stack>
      </Container>
    </Box>
  );
}
